import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { masarPaymobInt, masarPaymobIntTest } from "../../hooks/apiAxios"
import SuccessErrorMsg from "../../utilities/SuccessErrorMsg"
import { allServicesCategories } from '../../data/CategoriesData';
import Cookies from 'js-cookie';
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { RiyalImgBLK, RiyalImgWHT } from "../../components/common/RiyalImg";
import { useUser } from '../../context/User/UserContext';
import { useUserCart } from '../../context/User/UserCartContext';
import { usePaymentTok } from '../../context/PaymentTokContext';

export const PaymentForm = () => {
    const { profile, loading, setLoading } = useUser();
    const { cartBooks, cartOrders, cartStats } = useUserCart();
    const { paymentToken } = usePaymentTok();
    const [testMode] = useState(false);
    const [shipCost, setShipCost] = useState(25); // Default shipping cost
    const { t, i18n } = useTranslation();

    const paymentMethodsTest = [5745];
    const paymentMethods = [5846, 5847];
    const paymentType = sessionStorage.getItem('paymentType');

    const firstName = profile?.data?.firstName;
    const lastName = profile?.data?.lastName;
    const userEmail = profile?.data?.email;
    const userId = profile?.data?.id;

    const payAmount = paymentType === "services"
        ? Number(cartStats?.data?.totalOrdersPrice) || 0
        : (Number(cartStats?.data?.totalBooksPrice) || 0) + Number(shipCost);

    const { register, handleSubmit, setValue, formState: { errors }
    } = useForm({
        defaultValues: {
            currency: 'SAR',
            redirection_URL: 'https://masar-t.com.sa'
        }
    });

    const checkOutPayMob = (CSK) =>
        !testMode ?
            window.open(`${process.env.REACT_APP_PAYMOB_BASE_URL}/unifiedcheckout/?publicKey=${process.env.REACT_APP_PAYMOB_PUBLIC_KEY}&clientSecret=${CSK}`, '_self') :
            window.open(`${process.env.REACT_APP_PAYMOB_BASE_URL}/unifiedcheckout/?publicKey=${process.env.REACT_APP_PAYMOB_PUBLIC_TESTKEY}&clientSecret=${CSK}`, '_self');

    Cookies.set('paymentToken', paymentToken?.data, { expires: 7, secure: true, path: "/" });

    async function onSubmit(formData) {
        setLoading(true);
        console.log(formData);
        try {
            const response = await (testMode ? masarPaymobIntTest : masarPaymobInt)(formData);
            if (response.data.id) {
                toast.success(t("PaymentRedirect"))
                setTimeout(() => {
                    // window.location.reload();
                    checkOutPayMob(response.data.client_secret)
                    sessionStorage.removeItem("paymentType");
                }, 3000);
            } else {
                toast.error(t("errorTryAgain"));
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.warn(t("errorGetSupport"));
        } finally {
            setLoading(false);
        }
    }

    if (loading) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    if (!paymentToken) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;

    return (
        <form className='container d-flex flex-wrap flex-column flex-md-row mt-5 ' onSubmit={handleSubmit(onSubmit)}>
            <div className='col-12 col-md-7'>
                <div>
                    <h5 className='c-darkBeige'>{t("PayDetails")}</h5>
                    {!payAmount ?
                        <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"></span>
                        :
                        <div className='bg-light-beige p-1 rounded text-white text-end col-12 col-md-10 border-0 mb-3'>
                            <input name="amount"
                                // value={payAmount}
                                value={new Intl.NumberFormat("en-SA", {
                                    style: 'decimal', maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                }).format(payAmount)}

                                {...register("amount", setValue("amount", (payAmount) * 100))}
                                disabled
                                className='border-0 bg-light-beige text-white text-end fs-4'
                            >
                            </input>
                            <RiyalImgWHT />
                        </div>
                    }
                    <p className='c-darkOrange '>
                        {t("PayType")}
                    </p>
                    <div className='d-flex flex-column flex-md-row justify-content-center flex-wrap gap-1 my-3  align-items-center bg-light-gray p-1 rounded  text-center col-12 col-md-10'>
                        {(testMode ? paymentMethodsTest : paymentMethods).map((item, index) =>
                            <div key={index} className=''>
                                <input type="radio" className={`btn-check`} name="payment_methods"
                                    id={item} autoComplete="off"
                                    required
                                    onChange={e => setValue("payment_methods", [item])}
                                />
                                <label className={`${errors.payment_methods && "border-2 border-danger"} btn btn-light`} htmlFor={item}>
                                    <img className='pay-options'
                                        src={`/images/payment/${item}paySA.png`}
                                        alt={`${item}_pay`} /></label>
                                {errors.payment_methods && <p className='errors-msg'>{t("ChooseOne")}</p>}
                            </div>
                        )}
                    </div>
                </div>
                <div className='col-12 col-md-10'>

                    {/* <h6>معلومات الفوترة</h6> */}
                    {!profile ?
                        <span
                            className="spinner-border spinner-border-sm slef"
                            role="status"
                            aria-hidden="true"></span>
                        :
                        <>
                            <div className="input-group input-group-sm py-1">
                                <input
                                    className={`form-control ${errors.first_name && "border border-danger"}`}
                                    type="hidden"
                                    // type="text"
                                    name='first_name'
                                    defaultValue={firstName}
                                    required
                                    {...register("billing_data.first_name", { required: true })}
                                />
                                <input
                                    className={`form-control ${errors.first_name && "border border-danger"}`}
                                    type="hidden"
                                    {...register("customer.first_name")}
                                    value={firstName}
                                />
                                {errors.first_name && <p className='errors-msg'>{t("requiered")}</p>}
                            </div>
                            <div className="input-group input-group-sm  py-1">
                                <input className={`form-control ${errors.last_name && "border border-danger"}`}
                                    type="hidden"
                                    // type="text"
                                    name='last_name'
                                    defaultValue={lastName}
                                    {...register("billing_data.last_name", { required: true })}
                                />
                                <input
                                    className={`form-control ${errors.first_name && "border border-danger"}`}
                                    type="hidden"
                                    {...register("customer.last_name")}
                                    value={lastName}
                                />
                                {errors.last_name && <p className='errors-msg'>{t("requiered")}</p>}
                            </div>
                            <div className="input-group input-group-sm  py-1">
                                <input className={`form-control ${errors.email && "border border-danger"}`}
                                    type="hidden"
                                    defaultValue={profile?.data?.email}
                                    required
                                    name='email'
                                    {...register("billing_data.email", { required: true })}
                                />
                                <input className={`form-control ${errors.email && "border border-danger"}`}
                                    type="hidden"
                                    value={userId}
                                    required
                                    name='userId'
                                    {...register("billing_data.floor")}
                                />
                                <input className={`form-control ${errors.email && "border border-danger"}`}
                                    type="hidden"
                                    value={paymentType}
                                    required
                                    name='paymentType'
                                    {...register("billing_data.building")}
                                />
                                <input
                                    className={`form-control ${errors.first_name && "border border-danger"}`}
                                    type="hidden"
                                    {...register("customer.email")}
                                    value={userEmail}
                                />
                            </div>
                            {paymentType === "services" ? "" :
                                <div className="input-group input-group-sm  py-1">
                                    <span className="input-group-text">{t("shipping")}</span>
                                    <select id="sortBooks" className="form-select form-select-sm"
                                        onChange={(e) => setShipCost(e.target.value)}>
                                        <option value="25">{t("Riyadh")}</option>
                                        <option value="40">{t("nonRiyadh")}</option>
                                    </select>
                                </div>
                            }
                            <div className="input-group input-group-sm  py-1">
                                <span className="input-group-text">{t("Phone")}</span>
                                <input className={`form-control text-start ${errors.phone_number && "border border-danger"}`}
                                    type="tel"
                                    name='phone_number'
                                    defaultValue={profile?.data?.mobilePhone}
                                    required
                                    {...register("billing_data.phone_number", { required: true })}
                                />
                            </div>
                            <div className="input-group input-group-sm  py-1">
                                <span className="input-group-text">{t("address")}</span>
                                <input className={`form-control ${errors.street && "border border-danger"}`}
                                    type="text"
                                    name='street'
                                    {...register("billing_data.street", { required: true })} />
                                {errors.street && <p className='errors-msg'>{t("errorName")}</p>}
                            </div>
                            <div className="input-group input-group-sm py-1">
                                <span className="input-group-text">{t("City")}</span>
                                <input className={`form-control ${errors.city && "border border-danger"}`}
                                    type="text"
                                    name='city'
                                    {...register("billing_data.city", { required: true })} />
                                {errors.city && <p className='errors-msg'>{t("requiered")}</p>}
                            </div>
                            <div className="d-none input-group input-group-sm py-1">
                                <span className="input-group-text">{t("Country")}</span>
                                <input className={`form-control`}
                                    type="text"
                                    defaultValue="Saudi Arabia"
                                    {...register("billing_data.country")} />
                            </div>
                        </>}
                </div>
            </div>
            <div
                className='d-flex flex-column justify-content-between col-12 col-md-5 bg-light-gray py-3 pe-3 ps-2 mt-3 mt-md-0 rounded'>
                <div>
                    <h6 className=''>{t("ProductService")}</h6>
                    {/* the following was (&) and replaced to be (&&) (to verify) */}
                    {(paymentType === "services" && !cartOrders) || (paymentType === "books" && !cartBooks) ?
                        <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"></span>
                        :
                        <>
                            {paymentType === "services" ?
                                (cartOrders?.data?.result.map((item, index) => (
                                    <div key={index} className="d-flex text-white bg-dark-gray mt-2 ms-2 p-1 col-12 rounded align-items-center px-2">
                                        {/* Service Name */}
                                        <span className="col-7">
                                            <input
                                                type="hidden"
                                                {...register(`items[${index}].name`)}
                                                value={item.service?.name}
                                            />
                                            {allServicesCategories.map(cat =>
                                                cat.en === item.service?.name ? (i18n.language === "ar" ? cat.ar : cat.en) : "")}
                                        </span>
                                        {/* Offer Price */}
                                        <span className="col text-end border-0 bg-transparent text-white">
                                            <input
                                                type="hidden"
                                                {...register(`items[${index}].amount`, { valueAsNumber: true })}
                                                value={item.offerDetails?.price * 100}
                                                readOnly
                                            />
                                            {/* {new Intl.NumberFormat("en-SA", { style: 'currency', currency: 'SAR' }).format(item.offerDetails?.price)} */}
                                            {new Intl.NumberFormat("en-SA", {
                                                style: 'decimal', maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            }).format(item.offerDetails?.price)}
                                            <RiyalImgWHT />
                                        </span>
                                        {/* Quantity */}
                                        <span className={`col-1 text-end ${!item.quantity && "d-none"}`}>
                                            <input
                                                type="hidden"
                                                {...register(`items[${index}].quantity`, { valueAsNumber: true })}
                                                value={item.quantity ? item.quantity : 1}
                                            />
                                            {item.quantity}
                                        </span>
                                    </div>
                                )))
                                : (
                                    cartBooks?.data?.result.map((item, index) => (
                                        <div key={index} className="d-flex text-white bg-dark-gray mt-2 ms-2 p-1 col-12 rounded align-items-center px-2">
                                            {/* Books Names */}
                                            <span className="col-7">
                                                <input
                                                    type="hidden"
                                                    {...register(`items[0].name`)}
                                                    value="Shipping Cost"
                                                />
                                                <input
                                                    type="hidden"
                                                    {...register(`items[${index + 1}].name`)}
                                                    value={item.book?.title}
                                                />

                                                {item.book?.title}
                                            </span>
                                            {/* Offer Price */}
                                            <span className="col text-end border-0 bg-transparent text-white">
                                                <input
                                                    type="hidden"
                                                    {...register(`items[0].amount`, { valueAsNumber: true })}
                                                    value={shipCost * 100}
                                                    readOnly
                                                />
                                                <input
                                                    type="hidden"
                                                    {...register(`items[${index + 1}].amount`, { valueAsNumber: true })}
                                                    value={item.book?.price * 100}
                                                    readOnly
                                                />
                                                {new Intl.NumberFormat("en-SA", {
                                                    style: 'decimal', maximumFractionDigits: 2,
                                                    minimumFractionDigits: 2
                                                }).format(item.book?.price)}
                                                <RiyalImgWHT />

                                            </span>
                                            {/* Quantity */}
                                            <span className={`col-1 text-end ${!item.quantity && "d-none"}`}>
                                                <input
                                                    type="hidden"
                                                    {...register(`items[0].quantity`, { valueAsNumber: true })}
                                                    value={1}
                                                />
                                                <input
                                                    type="hidden"
                                                    {...register(`items[${index + 1}].quantity`, { valueAsNumber: true })}
                                                    value={item.quantity ? item.quantity : 1}
                                                />
                                                {item.quantity}
                                            </span>
                                        </div>
                                    )))
                            }
                        </>}
                </div>
                {paymentType === "books" ?
                    <div className=' mt-3'>
                        <h6 className=''>{t("ExtraCosts")}</h6>
                        <div className="d-flex text-black bg-white mt-2 ms-2 p-1 col-12 rounded align-items-center px-2">
                            <span className="col-7">
                                {t("ShippingCost")}
                            </span>
                            <span className="col text-end border-0 bg-transparent text-black">
                                {new Intl.NumberFormat("en-SA", {
                                    style: 'decimal', maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                }).format(shipCost)}
                                <RiyalImgBLK />

                            </span>
                        </div>
                    </div>
                    : ""}
            </div>
            <br />
            <button className='btn-masar btn-dark-orange col-12 col-md-10 mx-auto my-3' type="submit">
                {/* the following was Useless conditional and reviewd by the next line (hashed for now) (to verify)*/}
                {/* {loading &&
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"></span>
                } */}

                {t("ToPaymentPage")}
            </button>
            <SuccessErrorMsg
                ToastContainer={ToastContainer} />
        </form>
    );
};

export default PaymentForm;
